'use strict';

var util = require('../../util/property-util');
var XMLWriter = require('./xml-writer');
var FileSaver = require('file-saver');

module.exports = /*@ngInject*/ ["GoogleMapsFactory", "$q", "$filter", "KmlFactory", function (GoogleMapsFactory, $q, $filter, KmlFactory) {
    var factory = {};

    factory.export = function (polylines, options, trainInfo) {
        var polylineDeferred = $q.defer();
        var labelsDeferred = $q.defer();
        var waypointsDeferred = $q.defer();
        var customReferenceAreasDeferred = $q.defer();

        var waypointsStyle;
        var customReferenceAreasSyle;

        var description = createKmlDescription(trainInfo);

        var dataPolylines = getKmlPolylines(polylines, options);

        polylineDeferred.resolve([dataPolylines.polylines.toString(), createFolderName(options.label)]);
        labelsDeferred.resolve([dataPolylines.labels.toString(), createFolderName("labels")]);

        var waypointsPromise = GoogleMapsFactory.getWaypoints(trainInfo.projectId);
        waypointsPromise.then(function (waypoints) {
            var color = KmlFactory.extractKmlColor(GoogleMapsFactory.getLegendItem("waypoints").style["background-color"], "55");
            waypointsStyle = createKmlStyle("waypointsStyle", color, 2);
            var waypointsKml = getKmlPolygons(waypoints, "waypointsStyle").toString();
            waypointsDeferred.resolve([waypointsKml, createFolderName("Waypoints")]);
        });
        var customReferenceAreasPromise = GoogleMapsFactory.getCustomReferenceAreas(trainInfo.projectId);
        customReferenceAreasPromise.then(function (referenceAreas) {
            var color = KmlFactory.extractKmlColor(GoogleMapsFactory.getLegendItem("drawings").style["background-color"], "55");
            customReferenceAreasSyle = createKmlStyle("customReferenceAreasSyle", color, 2);
            var customReferenceAreasKml = getKmlPolygons(referenceAreas, "customReferenceAreasSyle").toString();
            customReferenceAreasDeferred.resolve([customReferenceAreasKml, createFolderName("Custom Areas")]);
        });

        $q.all([polylineDeferred.promise, labelsDeferred.promise, waypointsDeferred.promise, customReferenceAreasDeferred.promise]).then(function (content) {
            var kml = "<?xml version=\"1.0\"?>" + "<Document>" + "<name>" + options.label + "</name>";
            kml = kml + description;

            // add the styles at the start of the document
            kml = kml + waypointsStyle;
            kml = kml + customReferenceAreasSyle;

            content.forEach(function (kmlElement) {
                kml = kml + "<Folder>" + kmlElement[1];
                kml = kml + kmlElement[0];
                kml = kml + "</Folder>";
            });
            kml = kml + "</Document>";
            downloadKml(kml, options, trainInfo);
        });
    };

    var downloadKml = function (kml, info, trainInfo) {
        var blob = new Blob([kml], {type: "text/plain;charset=utf-8"});

        var fromDate = $filter('tzdate')(new Date(trainInfo.from), 'HH:MM:ss YYYY-MM-dd');
        var toDate = $filter('tzdate')(new Date(trainInfo.to), 'HH:MM:ss YYYY-MM-dd');
        var fileName = info.label + "_"
            + trainInfo.projectName
            + "-" + trainInfo.relativeTrainId
            + " " + fromDate + ""
            + "_" + toDate +
            ".kml";
        FileSaver.saveAs(blob, fileName);
    };

    function createFolderName(name) {
        return "<name>" + name + "</name>";
    }

    function createKmlDescription(trainInfo) {
        var fromDate = $filter('tzdate')(new Date(trainInfo.from), 'HH:MM:ss YYYY-MM-dd');
        var toDate = $filter('tzdate')(new Date(trainInfo.to), 'HH:MM:ss YYYY-MM-dd');

        return "<description>"
            + trainInfo.projectName
            + "-train " + trainInfo.relativeTrainId
            + " from: " + fromDate + ""
            + " to: " + toDate +
            "</description>";
    }

    function createKmlStyle(id, color, width) {
        var xml = new XMLWriter;
        xml.startElement('Style').writeAttribute("id", id);
        xml.startElement('LineStyle').writeElement('color', color).writeElement('width', util.isDefined(width) ? width : 2).endElement();
        xml.startElement('PolyStyle').writeElement('color', color).endElement();
        xml.endElement(); //ends Style
        return xml.toString();
    }

    function getKmlPolylines(polylines, info) {
        var xml = new XMLWriter;
        var labelsXml = new XMLWriter;
        polylines.forEach(function (pl) {
            var coordinates = pl.getPath();
            var tmp = [];
            coordinates.forEach(function (coord) {
                tmp.push(coord);
            });
            if (util.isDefined(tmp[0]) && util.isDefined(tmp[1])) {
                var color = KmlFactory.extractKmlColor(pl.strokeColor);
                var value = info.formatFunction(pl.value, info.unit);
                //var value = KmlFactory.getStringForValue(info.property.name, pl.value, info.unit);
                var formattedTimestamp = $filter('tzdate')(pl.timestamp, 'HH:mm:ss');
                KmlFactory.createKmlPolyline(tmp[0], tmp[1], color, value, formattedTimestamp, xml, labelsXml);
            }
        });
        return {polylines: xml, labels: labelsXml};
    }//
    function getKmlPolygons(polygons, styleId) {
        var xml = new XMLWriter;
        KmlFactory.createKmlPolygons(polygons, styleId, xml);
        return xml;
    }

    return factory;
}];